import React from 'react';

export interface AppTexts {
    appName: {
        displayName: string;
        name: string;
    };
    busyInitializing: string;
    menu: {
        issuanceConfig: string;
        apiDocs: string;
        credentialTypes: string;
        userMaintenance: string;
        organizationMaintenance: string;
        logoff: string;
    };
    generic: {
        yes: string;
        no: string;
        ok: string;
        cancel: string;
        add: string;
        save: string;
        delete: string;
        edit: string;
        back: string;
        loading: string;
        accept: string;
        reject: string;
        search: string;
        startSearching: string;
        removeCredential: string;
        copiedToClipboard: string;
    };
    error: {
        retrievingData: string;
        errorCodes: {
            "ERR-1": string;
        };
        inputErrors: {
            requiredField: string;
            noSpacesAllowed: string;
            invalidEmail: string;
            invalidUrl: string;
            onlyNumbersAllowed: string;
        }
    };
    fields: {};
    screens: {
        header: {
            welcomeTitle: string;
            welcomeSubTitle: string;
            registerOrganization: string;
            about: string;
        },
    }
}

const getAppTextsEn = (): AppTexts => {
    return {
        menu: {
            credentialTypes: 'Credential Catalog',
            issuanceConfig: 'Issuer configurations',
            userMaintenance: 'Users',
            organizationMaintenance: 'Organizations',
            apiDocs: 'API Docs',
            logoff: 'Logoff'
        },
        generic: {
            yes: 'Ja',
            no: 'Nee',
            ok: 'OK',
            cancel: 'Cancel',
            add: 'Add',
            save: 'Save',
            edit: 'Edit',
            delete: 'Delete',
            back: 'Back',
            loading: 'Loading...',
            accept: 'Accept',
            reject: 'Reject',
            search: 'Search',
            startSearching: 'Start searching...',
            removeCredential: 'Remove credential',
            copiedToClipboard: 'Copied to clipboard'
        },
        error: {
            retrievingData: "Something went wrong while retrieving the data. Please try again later.",
            errorCodes: {
                "ERR-1": 'Error 1'
            },
            inputErrors: {
                requiredField: 'Required field',
                noSpacesAllowed: 'No spaces allowed',
                invalidEmail: 'Invalid email',
                invalidUrl: 'Invalid URL',
                onlyNumbersAllowed: 'Only numbers allowed'
            },
        },
        fields: {},
        screens: {
            header: {
                welcomeTitle: 'Tulip trust Bank',
                welcomeSubTitle: '',
                registerOrganization: 'Register organisation',
                about: 'About'
            },
        }
    } as AppTexts;
};

const flatten: (object: any, prefix?: string) => any = (object, prefix = '') =>
    Object.keys(object).reduce(
        (prev, element) =>
            object[element] &&
            typeof object[element] === 'object' &&
            !Array.isArray(object[element])
                ? {...prev, ...flatten(object[element], `${prefix}${element}.`)}
                : {...prev, ...{[`${prefix}${element}`]: object[element]}},
        {},
    );

export const getTranslations = (language: string): {} => {
    const appTexts = getAppTextsEn();
    return flatten(appTexts, '');
}
